// import { toast } from "react-toastify";
import React from "react";
// import { data } from "jquery";
import { TYPES } from "./types";
import { authenService } from "../services"; 
// eslint-disable-next-line no-unused-vars
// import { CONFIGS } from "../configs";
// import CustomToastIndex from "../views/extras/customToast";
// import { getTranslate, LANGUAGE_KEYS } from "../utils";

export const login = (username, password, company_id) => async (dispatch) => {
  try {
    console.log("authenService Login");
    const result = await authenService.login(username, password, company_id);
    const data = result.data;
    console.log(result, data);
    
    if (data && data.status === 1) {
      console.log("Success");
      dispatch({
        type: TYPES.ACTION_LOGIN_SUCCESS,
        payload: {
          user: { username: data.data.username },
          token: data.data.token
        }
      });
    } else {
      console.log("Login failed:", data?.message || "Unknown error");
      dispatch({
        type: TYPES.ACTION_LOGIN_FAIL,
        payload: {
          error: data?.message || "Login failed"
        },
      });
    }
  } catch (error) {
    console.log("Login error:", error);
    dispatch({
      type: TYPES.ACTION_LOGIN_FAIL,
      payload: {
        error: error?.response?.data?.message || error?.message || "Login failed"
      },
    });
  }
};

export const getUser = () => async (dispatch) => {
  try {
    const result = await authenService.getUser();
    const data = result.data;
    console.log("getUser", result, data);
    
    if (data.data) {
      dispatch({
        type: TYPES.ACTION_GET_USER_SUCCESS,
        payload: {
          user: data.data,
          token: data.data.token
        }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_USER_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const changePassword = (newPassword, currentPassword = "") => async (dispatch) => {
  try {
    const result = await authenService.changePassword(newPassword, currentPassword);
    const data = result.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CHANGE_PASSWORD_SUCCESS,
        payload: {
          user: data.data
        }
      });
      return true;
    } else {
      dispatch({
        type: TYPES.ACTION_CHANGE_PASSWORD_FAIL,
        payload: {},
      });
      return false;
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
    return false;
  }
};

export const authenActions = {
  login,
  getUser,
  changePassword
};
